var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"files"},[_c('h2',[_vm._v(_vm._s(_vm.content.field_headline))]),_c('ul',_vm._l((_vm.content.paragraph),function(item,index){return _c('file',{key:index,attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }